<template>
  <div class="kw_progress">
    <span :style="fieldInfo.styleSet.listFieldNameStyleSet?fieldInfo.styleSet.listFieldNameStyleSet.styleSetCode:''" kwName="listFieldNameStyleSet" v-if="(fieldInfo.styleSet.hasname!=2)">{{fieldInfo.fieldCnName}}:</span>
    <div v-if="dataInfo[fieldInfo.fieldAliasName+'_NOW'] == null">
      <el-progress :class="(!fieldInfo.styleSet.progressType||fieldInfo.styleSet.progressType=='circle'?'progressElebox':'')" :style="'display:inline-block;'+fieldInfo.styleSet.listFieldProgressStyleSet?fieldInfo.styleSet.listFieldProgressStyleSet.styleSetCode:''" :type="fieldInfo.styleSet.progressType?fieldInfo.styleSet.progressType:'circle'" :percentage="(dataInfo[fieldInfo.fieldAliasName]!=null&&dataInfo[fieldInfo.fieldAliasName]!=undefined&&dataInfo[fieldInfo.fieldAliasName]!='')?(dataInfo[fieldInfo.fieldAliasName]>100?100:dataInfo[fieldInfo.fieldAliasName]):0" :width="fieldInfo.styleSet.listFieldProgressStyleSet.width?(fieldInfo.styleSet.listFieldProgressStyleSet.width.substring(0,fieldInfo.styleSet.listFieldProgressStyleSet.width.length-2))*1:50" :stroke-width="fieldInfo.styleSet.listFieldProgressStyleSet.height?(fieldInfo.styleSet.listFieldProgressStyleSet.height.substring(0,fieldInfo.styleSet.listFieldProgressStyleSet.height.length-2))*1:6" :color="dataInfo[fieldInfo.fieldAliasName+'_COLOR']?dataInfo[fieldInfo.fieldAliasName+'_COLOR']:(fieldInfo.styleSet.progressColor?fieldInfo.styleSet.progressColor:'')" :show-text="false"></el-progress>
      <span :class="'zdyKwClass'" :style="fieldInfo.styleSet.listFieldProgressDivisionStyleSet?styleSetCodeZdy(fieldInfo.styleSet.listFieldProgressDivisionStyleSet,dataInfo):''" kwName="listFieldProgressDivisionStyleSet">{{(dataInfo[fieldInfo.fieldAliasName]!=null&&dataInfo[fieldInfo.fieldAliasName]!=undefined&&dataInfo[fieldInfo.fieldAliasName]!='')?(dataInfo[fieldInfo.fieldAliasName]>100?100:dataInfo[fieldInfo.fieldAliasName]):0}}%</span>
    </div>
    <div v-else class="progressbox" :style="fieldInfo.styleSet.listFieldProgressStyleSet?fieldInfo.styleSet.listFieldProgressStyleSet.styleSetCode:''" kwName="listFieldProgressStyleSet">
		  <span  :style="fieldInfo.styleSet.listFieldProgressMoleculeStyleSet?fieldInfo.styleSet.listFieldProgressMoleculeStyleSet.styleSetCode:''" kwName="listFieldProgressMoleculeStyleSet">{{dataInfo[fieldInfo.fieldAliasName+'_NOW']}}</span>
      <span :style="fieldInfo.styleSet.listFieldProgressDivisionStyleSet?fieldInfo.styleSet.listFieldProgressDivisionStyleSet.styleSetCode:''" kwName="listFieldProgressDivisionStyleSet">/</span>
      <span :style="fieldInfo.styleSet.listFieldProgressDenominatorStyleSet?fieldInfo.styleSet.listFieldProgressDenominatorStyleSet.styleSetCode:''" kwName="listFieldProgressDenominatorStyleSet">{{dataInfo[fieldInfo.fieldAliasName]}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kw_progress',
  props: {
    //树的数据内容
    dataInfo: {
      type: Object,
      value: null
    },
    fieldInfo: {
      type: Object,
      value: null
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    styleSetCodeZdy(json,rowData) {
      var styleSetCode = json.styleSetCode;
      if(json.zdyJs) {
        styleSetCode += eval(json.zdyJs);
      }
      return styleSetCode;
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.zdyKwClass{
  font-size: 12px;
}
.zdyKwClass_red{
  font-size: 12px;
  color: rgb(255, 87, 100);
}
.zdyKwClass_green{
  font-size: 12px;
  color: rgb(62, 197, 0);
}
.zdyKwClass_orange{
  font-size: 12px;
  color: rgb(255, 138, 0);
}
</style>
<style scoped>
.progressElebox {width:50px;height:50px;line-height:50px;text-align:center;position:absolute;right:0;top:-10px}
.progressbox {color:#C0C0C0;font-size:16px;width:50px;height:50px;line-height:50px;border:2px solid #FFE0CD;border-radius: 50%;text-align:center;position:absolute;right:0;top:50%;transform: translateY(-25px);}

</style>
